$easyreels_user_upload $mol_view
	files? /File
	retry? null
	sub <= content /$mol_view
		<= Pick $mol_button_open
			sub /
				<= Pick_icon $mol_icon_upload
				<= Pick_title $mol_view
					sub /
						<= pick_title @ \Upload a file
				<= Pick_native $mol_button_open_native
					files? <=> files?
					accept \video/*,audio/*
					multiple false
		<= Bar $mol_portion
			portion <= ratio 0
		<= Message $mol_paragraph
			title <= message \
		<= Detail $mol_paragraph
			title <= detail \
		<= Retry_button $mol_button_minor
			title @ \Try again
			click? <=> retry?
